// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/as.avif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 20px;
}

.shop-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.shop-card {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 200px;
  cursor: pointer;
  transition: transform 0.2s;
}

.shop-card:hover {
  transform: scale(1.05);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-content {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding: 20px;
  border-radius: 10px;
  width: 80%; /* adjusted width to allow scrolling */
  height: 80vh; /* set height to enable scrolling */
  position: relative;
  overflow-y: auto; /* enable vertical scrolling */
  z-index: 1;
}

.modal-content input {
  margin: 2px;
  text-align: left;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}

/* Global container padding for small screens */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 10px;
  }

  .modal-content {
    width: 95%;
    height: 70vh;
    padding: 10px;
  }

  .dashboard {
    width: 100vw;
    margin-left: 0;
    padding: 15px;
  }

  .product-cards-container {
    flex-direction: column;
    gap: 15px;
  }

  .shop-card,
  .product-card {
    width: 100%;
    max-width: 100%;
  }

  .product-card {
    flex-direction: column;
    text-align: center;
  }

  .product-image {
    width: 80px;
    height: 80px;
  }

  .product-details-column {
    padding-left: 0;
  }

  .shop-card {
    padding: 15px;
  }
}

/* Adjustments for tablets */
@media (min-width: 769px) and (max-width: 1024px) {
  .dashboard-container {
    padding: 15px;
  }

  .dashboard {
    width: 90vw;
    margin-left: 5%;
  }

  .shop-card {
    width: 45%;
  }

  .modal-content {
    width: 90%;
    height: 75vh;
    padding: 15px;
  }

  .product-card {
    width: 100%;
    flex-direction: row;
  }

  .product-image {
    width: 90px;
    height: 90px;
  }
}

/* Large screens */
@media (min-width: 1025px) {
  .dashboard-container {
    padding: 20px;
  }

  .dashboard {
    width: 80vw;
    margin-left: 10%;
  }

  .shop-card {
    width: 200px;
  }

  .product-card {
    width: 100%;
    max-width: 500px;
    flex-direction: row;
  }

  .product-image {
    width: 100px;
    height: 100px;
  }

  .product-details-column {
    padding-left: 20px;
  }
}

/* General responsiveness for all elements */
@media (max-width: 480px) {
  h2,
  .product-ti {
    font-size: 24px;
  }

  .product-stock,
  .product-price {
    font-size: 18px;
  }

  .shop-card {
    padding: 10px;
  }

  .modal-content {
    padding: 10px;
    height: 60vh;
    overflow-y: auto;
  }

  .product-image {
    width: 70px;
    height: 70px;
  }

  .product-des {
    font-size: 18px;
  }
}

h3.mt-4 {
  margin-top: 20px;
}

.product-form {
  display: flex;
  flex-direction: column;
}

.product-form input {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.product-form button {
  padding: 10px;
  background-color: #27ae60;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.product-form .delete-button {
  background-color: #e74c3c;
}

.preview-img {
  margin-top: 10px;
  max-width: 100px;
}

.tit {
  color: #27ae60;
  text-transform: uppercase;
}

.dashboard {
  padding: 30px;
  background-image: linear-gradient(135deg, #00465849 0%, #027c9a64 100%);
  width: 80vw;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-top: 10%;
  margin-left: 10%;
  position: absolute;
}

.shop-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.shop-card {
  border-radius: 8px;
  padding: 20px;
  width: 300px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.shop-card:hover {
  transform: translateY(-5px);
}

.shop-card h3 {
  margin-bottom: 10px;
  text-align: center;
}

.shop-card p {
  margin-bottom: 5px;
  text-align: left;
}

h2 {
  margin-bottom: 3%;
  text-transform: uppercase;
  font-size: 36px;
  font-weight: bold;
  color: #28a745;
}

.product-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.product-card {
  background-image: linear-gradient(135deg, #00465849 0%, #027c9a64 100%);
  border: 1px solid #ddd;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  width: 100%;
  max-width: 500px;
  padding: 20px;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image-column {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-details-column {
  flex: 2 1;
  padding-left: 20px;
}

.product-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

input[type="text"],
input[type="file"],
textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
}

/* Add hover effect to inputs */
input[type="text"]:focus,
textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 3px rgba(0, 123, 255, 0.3);
}

.space {
  margin-top: 10px;
  padding-left: 10px;
}

.product-price {
  font-size: 26px;
  font-weight: bold;
  color: #28a745;
  text-align: left;
}

.currency-icon {
  margin-right: 5px;
}

/* Stock label */
.product-stock {
  font-size: 20px;
  color: #2600ff; /* Red for low stock */
  text-align: left;
  font-weight: normal;
}

.product-ti {
  margin-top: 4%;
  font-size: 36px;
  font-weight: bold;
  color: #28a745;
  text-transform: uppercase;
}

.product-des {
  margin-bottom: 4%;
  font-size: 25px;
  font-style: italic;
  background-color: #004658;
  color: #027b9a;
  box-shadow: 0 0 3px rgba(0, 123, 255, 0.3);
  padding: 10px;
  border: 2px #027b9a dashed;
  border-radius: 15px;
  text-align: left;
}

.product-des:hover {
  background-color: #027b9a;
  color: #004658;
  border: 2px #004658 dashed;
  transition: cubic-bezier(1, 0, 0, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,yDAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAE,sCAAsC;EAClD,YAAY,EAAE,mCAAmC;EACjD,kBAAkB;EAClB,gBAAgB,EAAE,8BAA8B;EAChD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;EACvE,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;EAEE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc,EAAE,sBAAsB;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,oCAAoC;AACtC","sourcesContent":[".dashboard-container {\n  padding: 20px;\n}\n\n.shop-cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.shop-card {\n  background-color: #fff;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 200px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.shop-card:hover {\n  transform: scale(1.05);\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.modal-content {\n  background-color: #fff;\n  background-image: url(../../public/as.avif);\n  padding: 20px;\n  border-radius: 10px;\n  width: 80%; /* adjusted width to allow scrolling */\n  height: 80vh; /* set height to enable scrolling */\n  position: relative;\n  overflow-y: auto; /* enable vertical scrolling */\n  z-index: 1;\n}\n\n.modal-content input {\n  margin: 2px;\n  text-align: left;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n/* Global container padding for small screens */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 10px;\n  }\n\n  .modal-content {\n    width: 95%;\n    height: 70vh;\n    padding: 10px;\n  }\n\n  .dashboard {\n    width: 100vw;\n    margin-left: 0;\n    padding: 15px;\n  }\n\n  .product-cards-container {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .shop-card,\n  .product-card {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .product-card {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .product-image {\n    width: 80px;\n    height: 80px;\n  }\n\n  .product-details-column {\n    padding-left: 0;\n  }\n\n  .shop-card {\n    padding: 15px;\n  }\n}\n\n/* Adjustments for tablets */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .dashboard-container {\n    padding: 15px;\n  }\n\n  .dashboard {\n    width: 90vw;\n    margin-left: 5%;\n  }\n\n  .shop-card {\n    width: 45%;\n  }\n\n  .modal-content {\n    width: 90%;\n    height: 75vh;\n    padding: 15px;\n  }\n\n  .product-card {\n    width: 100%;\n    flex-direction: row;\n  }\n\n  .product-image {\n    width: 90px;\n    height: 90px;\n  }\n}\n\n/* Large screens */\n@media (min-width: 1025px) {\n  .dashboard-container {\n    padding: 20px;\n  }\n\n  .dashboard {\n    width: 80vw;\n    margin-left: 10%;\n  }\n\n  .shop-card {\n    width: 200px;\n  }\n\n  .product-card {\n    width: 100%;\n    max-width: 500px;\n    flex-direction: row;\n  }\n\n  .product-image {\n    width: 100px;\n    height: 100px;\n  }\n\n  .product-details-column {\n    padding-left: 20px;\n  }\n}\n\n/* General responsiveness for all elements */\n@media (max-width: 480px) {\n  h2,\n  .product-ti {\n    font-size: 24px;\n  }\n\n  .product-stock,\n  .product-price {\n    font-size: 18px;\n  }\n\n  .shop-card {\n    padding: 10px;\n  }\n\n  .modal-content {\n    padding: 10px;\n    height: 60vh;\n    overflow-y: auto;\n  }\n\n  .product-image {\n    width: 70px;\n    height: 70px;\n  }\n\n  .product-des {\n    font-size: 18px;\n  }\n}\n\nh3.mt-4 {\n  margin-top: 20px;\n}\n\n.product-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.product-form input {\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.product-form button {\n  padding: 10px;\n  background-color: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.product-form .delete-button {\n  background-color: #e74c3c;\n}\n\n.preview-img {\n  margin-top: 10px;\n  max-width: 100px;\n}\n\n.tit {\n  color: #27ae60;\n  text-transform: uppercase;\n}\n\n.dashboard {\n  padding: 30px;\n  background-image: linear-gradient(135deg, #00465849 0%, #027c9a64 100%);\n  width: 80vw;\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  margin-top: 10%;\n  margin-left: 10%;\n  position: absolute;\n}\n\n.shop-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.shop-card {\n  border-radius: 8px;\n  padding: 20px;\n  width: 300px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.shop-card:hover {\n  transform: translateY(-5px);\n}\n\n.shop-card h3 {\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.shop-card p {\n  margin-bottom: 5px;\n  text-align: left;\n}\n\nh2 {\n  margin-bottom: 3%;\n  text-transform: uppercase;\n  font-size: 36px;\n  font-weight: bold;\n  color: #28a745;\n}\n\n.product-cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.product-card {\n  background-image: linear-gradient(135deg, #00465849 0%, #027c9a64 100%);\n  border: 1px solid #ddd;\n  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  display: flex;\n  width: 100%;\n  max-width: 500px;\n  padding: 20px;\n  cursor: pointer;\n}\n\n.product-card:hover {\n  transform: translateY(-5px);\n}\n\n.product-image-column {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-details-column {\n  flex: 2;\n  padding-left: 20px;\n}\n\n.product-image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n}\n\nlabel {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #333;\n}\n\ninput[type=\"text\"],\ninput[type=\"file\"],\ntextarea {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  font-size: 14px;\n}\n\n/* Add hover effect to inputs */\ninput[type=\"text\"]:focus,\ntextarea:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 3px rgba(0, 123, 255, 0.3);\n}\n\n.space {\n  margin-top: 10px;\n  padding-left: 10px;\n}\n\n.product-price {\n  font-size: 26px;\n  font-weight: bold;\n  color: #28a745;\n  text-align: left;\n}\n\n.currency-icon {\n  margin-right: 5px;\n}\n\n/* Stock label */\n.product-stock {\n  font-size: 20px;\n  color: #2600ff; /* Red for low stock */\n  text-align: left;\n  font-weight: normal;\n}\n\n.product-ti {\n  margin-top: 4%;\n  font-size: 36px;\n  font-weight: bold;\n  color: #28a745;\n  text-transform: uppercase;\n}\n\n.product-des {\n  margin-bottom: 4%;\n  font-size: 25px;\n  font-style: italic;\n  background-color: #004658;\n  color: #027b9a;\n  box-shadow: 0 0 3px rgba(0, 123, 255, 0.3);\n  padding: 10px;\n  border: 2px #027b9a dashed;\n  border-radius: 15px;\n  text-align: left;\n}\n\n.product-des:hover {\n  background-color: #027b9a;\n  color: #004658;\n  border: 2px #004658 dashed;\n  transition: cubic-bezier(1, 0, 0, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
